import "./style.scss";
import { FC } from "react";
import { Link } from "react-router-dom";
import { INavigationData } from "@/src/types/INavigation";

const NavigationItem: FC<INavigationData> = ({ id, link, image: Image, text }) => {
  return (
    <Link to={`${link !== undefined ? `${link}` : `/navigation/${id}`}`} className="navigation-item">
      <div className="navigation-item-svg">
        <Image />
      </div>
      <div className="navigation-item-text">
        <p>{text}</p>
      </div>
    </Link>
  );
};

export default NavigationItem;
